const extractHostname = (input) => {
  try {
    return new URL(input).hostname;
  } catch {
    try {
      return new URL(`https://${input}`).hostname;
    } catch {
      return null;
    }
  }
};

export const checkDomainExists = async (input) => {
  try {
    const hostname = extractHostname(input);
    if (!hostname) return false;

    const res = await fetch(
      `https://dns.google/resolve?name=${encodeURIComponent(hostname)}&type=A`
    );
    const data = await res.json();

    return Array.isArray(data.Answer) && data.Answer.length > 0;
  } catch {
    return false;
  }
};